export enum PlayerActionTypes {
  PLAY_SOUND = '@@player/PLAY_SOUND',
  SET_CURRENT_TIME = '@@player/SET_CURRENT_TIME'
}
